import script from "./DMI.vue?vue&type=script&lang=js"
export * from "./DMI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__